/* Puff Land – fiche produit et aperçu rapide (module différé, sans dépendance ; s'appuie sur theme.js : window.PL) */
(() => {
  'use strict';
  const PL = window.PL;
  if (!PL || !PL.u || PL.loaded_product) return;
  PL.loaded_product = true;
  const { $, $$, debounce, parseHTML, storage, formatMoney, toast, esc, starsHTML, isDesktop, reduceMotion, initWishlistButtons } = PL.u;
  const S = PL.strings;
  const Cart = PL.cart;
  const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
  const smooth = () => (reduceMotion ? 'auto' : 'smooth');

  /* Variantes de la fiche (snippets/product-variants-json) */
  const variantsOf = (info) => {
    if (!info) return [];
    if (info.plVariants) return info.plVariants;
    const el = $('script[data-product-json]', info);
    let list = [];
    try { list = JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { list = []; }
    info.plVariants = list;
    return list;
  };
  /* Libellé « Plus que X en stock » (traduit, pluriel géré par Shopify : modèles « 1 » et « 7777 ») */
  const lowText = (info, n) => {
    const el = $('[data-stock]', info) || $('[data-stock]');
    if (!el) return '';
    return n === 1 ? el.dataset.labelLowOne : String(el.dataset.labelLowOther || '').replace('7777', n);
  };
  const openRestock = (info) => {
    const box = $('[data-restock]', info);
    if (!box) return;
    box.hidden = false;
    box.scrollIntoView({ behavior: smooth(), block: 'center' });
    const input = $('[data-restock-email]', box);
    if (input) input.focus({ preventScroll: true });
  };
  PL.openRestock = openRestock;

  /* ---------- Sélecteur de variantes ---------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      if (!this.info) return;
      this.variants = variantsOf(this.info);
      this.status = $('[data-variant-status]', this);
      this.locked = this.hasAttribute('data-soldout-locked');
      this.addEventListener('change', (e) => this.onChange(e));
      this.refresh(this.selected());
      this.initFold();
    }
    // Ordinateur, plus de 8 valeurs : les rangées qui tiennent dans 120 px (écran de moins de 800 px de haut) ou 220 px restent
    // visibles, le reste derrière « Voir les N saveurs », pour que « Ajouter au panier » soit visible dès l'arrivée
    initFold() {
      const btns = $$('[data-vp-more]', this);
      if (!btns.length) return;
      const mq = window.matchMedia('(min-width: 990px)');
      btns.forEach((btn) => {
        const list = document.getElementById(btn.getAttribute('aria-controls'));
        if (!list) return;
        const more = $('[data-vp-more-label]', btn);
        const less = $('[data-vp-less-label]', btn);
        const set = (open) => {
          btn.setAttribute('aria-expanded', String(open));
          list.classList.toggle('is-folded', !open && !btn.hidden);
          more.hidden = open;
          less.hidden = !open;
        };
        const measure = () => {
          list.classList.remove('is-folded');
          list.style.removeProperty('--vp-max');
          const items = $$('.variant-picker__value', list);
          const top = list.getBoundingClientRect().top;
          const rows = [...new Set(items.map((el) => Math.round(el.getBoundingClientRect().top - top)))].sort((a, b) => a - b);
          const bottoms = rows.map((r) => Math.max(...items.filter((el) => Math.round(el.getBoundingClientRect().top - top) === r).map((el) => el.getBoundingClientRect().bottom - top)));
          const limit = window.innerHeight < 800 ? 120 : 220;
          let keep = 1;
          while (keep < rows.length && bottoms[keep] <= limit) keep += 1;
          btn.hidden = !mq.matches || rows.length <= keep;
          if (btn.hidden) { set(true); return; }
          list.style.setProperty('--vp-max', `${rows[keep] - 4}px`);
          // Valeur choisie dans une rangée repliée (lien vers une variante précise) : la liste reste dépliée
          const checked = $('input:checked', list);
          const label = checked && list.querySelector(`label[for="${checked.id}"]`);
          const hiddenChoice = label && label.getBoundingClientRect().top - top >= rows[keep];
          set(btn.getAttribute('aria-expanded') === 'true' || Boolean(hiddenChoice));
        };
        btn.addEventListener('click', () => set(btn.getAttribute('aria-expanded') !== 'true'));
        // Clavier : une valeur repliée qui reçoit le focus déplie la liste
        list.addEventListener('focusin', (e) => {
          if (!list.classList.contains('is-folded')) return;
          const label = e.target.id && list.querySelector(`label[for="${e.target.id}"]`);
          if (label && label.getBoundingClientRect().bottom > list.getBoundingClientRect().bottom) set(true);
        });
        measure();
        mq.addEventListener('change', measure);
        let t;
        window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(measure, 150); });
      });
    }
    options() { return $$('.variant-picker__option', this); }
    selected() {
      return this.options().map((fs) => {
        const sel = $('select', fs);
        if (sel) return sel.value;
        const c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    setSelected(values) {
      this.options().forEach((fs, i) => {
        const sel = $('select', fs);
        if (sel) { sel.value = values[i]; return; }
        $$('input', fs).forEach((inp) => { inp.checked = inp.value === values[i]; });
      });
    }
    /* Combinaison exacte, sinon la variante qui garde la valeur choisie et le plus d'options identiques (disponible en priorité) */
    find(values, changed) {
      const exact = this.variants.find((v) => v.options.every((o, i) => o === values[i]));
      if (exact) return exact;
      const pool = this.variants.filter((v) => changed === null || v.options[changed] === values[changed]);
      const score = (v) => v.options.reduce((n, o, i) => n + (o === values[i] ? 2 : 0), 0) + (v.available ? 1 : 0);
      return pool.sort((a, b) => score(b) - score(a))[0] || null;
    }
    onChange(e) {
      const idx = Number(e.target && e.target.dataset ? e.target.dataset.optionIndex : NaN);
      let values = this.selected();
      const v = this.find(values, Number.isNaN(idx) ? null : idx);
      if (!v) return;
      if (v.options.some((o, i) => o !== values[i])) { this.setSelected(v.options); values = v.options.slice(); }
      this.refresh(values);
      this.info.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: v }));
      this.announce(v);
    }
    /* Valeurs épuisées (selon les autres options choisies) : barrées, signalées aux lecteurs d'écran, toujours cliquables sauf réglage contraire */
    refresh(values) {
      $$('[data-selected-value]', this).forEach((el) => { el.textContent = values[Number(el.dataset.selectedValue)] || ''; });
      this.options().forEach((fs, i) => {
        const ok = (value) => this.variants.some((v) => v.available && v.options[i] === value && v.options.every((o, j) => j === i || o === values[j]));
        $$('input', fs).forEach((inp) => {
          const avail = ok(inp.value);
          const label = fs.querySelector(`label[for="${CSS.escape(inp.id)}"]`);
          if (label) {
            label.classList.toggle('is-unavailable', !avail);
            const sr = $('[data-unavailable-text]', label);
            if (sr) sr.hidden = avail;
          }
          if (this.locked) inp.disabled = !avail && !inp.checked;
        });
        const sel = $('select', fs);
        if (sel) {
          Array.from(sel.options).forEach((o) => {
            const avail = ok(o.value);
            o.textContent = avail ? o.value : `${o.value} – ${S.stockOut}`;
            if (this.locked) o.disabled = !avail && !o.selected;
          });
        }
      });
    }
    announce(v) {
      if (!this.status) return;
      let st = S.stockIn;
      if (v.over) st = S.overLimit;
      else if (!v.available) st = S.soldoutNotice;
      else if (v.low > 0) st = lowText(this.info, v.low);
      else if (v.backorder) st = S.stockBackorder;
      this.status.textContent = fill(S.variantStatus, { variant: v.title, status: st });
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);

  /* ---------- Mise à jour de la fiche au changement de variante ---------- */
  const updatePrice = (info, v) => {
    const onSale = v.compare_at_price > v.price;
    $$('[data-price-wrap] .price', info).forEach((wrap) => {
      wrap.classList.toggle('price--sale', onSale);
      const current = $('.price__current', wrap);
      if (current) {
        let hidden = $('.visually-hidden', current);
        current.textContent = ` ${formatMoney(v.price)}`;
        if (!hidden) { hidden = document.createElement('span'); hidden.className = 'visually-hidden'; }
        hidden.textContent = onSale ? (wrap.dataset.labelSale || '') : (wrap.dataset.labelRegular || '');
        current.prepend(hidden);
      }
      let cmp = $('.price__compare', wrap);
      if (onSale) {
        if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; current.after(cmp); }
        cmp.innerHTML = `<span class="visually-hidden">${esc(wrap.dataset.labelCompare || '')}</span>${esc(formatMoney(v.compare_at_price))}`;
      } else if (cmp) cmp.remove();
      let unit = $('.price__unit', wrap);
      if (v.unit) {
        if (!unit) { unit = document.createElement('span'); unit.className = 'price__unit'; wrap.appendChild(unit); }
        unit.textContent = v.unit;
      } else if (unit) unit.remove();
    });
    const pct = onSale ? Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
    $$('[data-discount-badge]', info).forEach((b) => {
      b.hidden = !(pct > 0 && pct >= Number(b.dataset.min || 1));
      const txt = $('[data-discount-text]', b);
      if (txt) txt.textContent = String(txt.dataset.template || '-7777 %').replace('7777', pct);
      const sr = $('[data-discount-sr]', b);
      if (sr) sr.textContent = String(sr.dataset.template || '').replace('7777', pct);
    });
    $$('[data-omnibus]', info).forEach((el) => { el.hidden = !onSale; });
  };

  const updateStock = (info, v) => {
    $$('[data-stock]', info).forEach((el) => {
      let state = 'out';
      let text = el.dataset.labelOut;
      if (v.available) {
        state = 'in'; text = el.dataset.labelIn;
        if (v.low > 0) { state = 'low'; text = lowText(info, v.low); }
        else if (v.backorder) { state = 'backorder'; text = el.dataset.labelBackorder; }
      }
      el.className = `stock stock--${state}`;
      const t = $('[data-stock-text]', el);
      if (t) t.textContent = text;
    });
  };

  /* Modes : add · notify (épuisée, alerte de retour) · soldout · blocked (dosage au-delà de 20 mg/ml : jamais d'alerte) */
  const setMode = (btn, labelEl, mode) => {
    if (!btn) return;
    btn.dataset.mode = mode;
    btn.disabled = mode === 'soldout' || mode === 'blocked';
    if (labelEl) labelEl.textContent = labelEl.dataset[{ add: 'labelAdd', notify: 'labelNotify', blocked: 'labelBlocked' }[mode] || 'labelSoldout'] || labelEl.dataset.labelSoldout || labelEl.textContent;
  };
  const modeFor = (info, v) => {
    if (v.available) return 'add';
    if (v.over) return 'blocked';
    return $('[data-restock]', info) ? 'notify' : 'soldout';
  };

  const updateBuy = (info, v) => {
    const mode = modeFor(info, v);
    $$('[data-add-button]', info).forEach((btn) => setMode(btn, $('[data-add-label]', btn), mode));
    $$('[data-buy-now], [data-dynamic-checkout]', info).forEach((el) => { el.hidden = !v.available; });
    const box = $('[data-restock]', info);
    if (box) {
      box.hidden = !!v.available || !!v.over;
      const field = $('[data-restock-variant]', box);
      if (field) field.value = `${v.title} (ID ${v.id})`;
    }
    let over = $('[data-over-limit]', info);
    if (v.over && !over) {
      const buy = $('.product__buy', info);
      if (buy) {
        over = document.createElement('p');
        over.className = 'product__over-limit';
        over.setAttribute('role', 'note');
        over.dataset.overLimit = '';
        const text = document.createElement('span');
        text.textContent = S.overLimit;
        over.appendChild(text);
        buy.before(over);
      }
    } else if (over) over.hidden = !v.over;
    $$('[data-delivery], [data-delivery-head]', info).forEach((el) => { el.hidden = !v.available; });
    const err = $('[data-form-error]', info);
    if (err) err.hidden = true;
  };

  document.addEventListener('variant:change', (e) => {
    const info = e.target.closest && e.target.closest('product-info');
    const v = e.detail;
    if (!info || !v) return;
    $$('[data-variant-id]', info).forEach((input) => { input.value = v.id; });
    if (!info.closest('dialog')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url.toString());
    }
    updatePrice(info, v);
    updateStock(info, v);
    updateBuy(info, v);
    const gallery = $('media-gallery', info);
    if (gallery && gallery.showVariant) gallery.showVariant(v);
    if (PL.badges) $$('[data-badges]', info).forEach((box) => { if (box.dataset.handle === info.dataset.handle) PL.badges.variant(box, v); });
    /* Avertissement nicotine : texte de la déclinaison sans nicotine ou texte officiel (le bloc reste toujours affiché) */
    $$('[data-nic-zero]', info).forEach((box) => {
      const zero = box.dataset.nicZero.includes(`;${v.id};`);
      $$('[data-nic-text]', box).forEach((p) => { p.hidden = (p.dataset.nicText === 'off') !== zero; });
    });
    /* Caractéristique « Nicotine » : dosage de la variante choisie */
    $$('[data-spec-nic]', info).forEach((el) => {
      const raw = String(v.options[Number(el.dataset.specNic)] || '').toLowerCase().replace(/\s/g, '').replace(',', '.');
      let n = /sansnicotine|nicotinefree/.test(raw) ? 0 : parseFloat(raw);
      if (Number.isNaN(n)) return;
      if (raw.includes('%')) n = Math.round(n * 10);
      el.textContent = `${String(n).replace('.', ',')} mg/ml`;
    });
    $$('pl-bundle', info).forEach((b) => { if (b.setMain) b.setMain(v); });
  });

  /* Formulaire d'achat : « M'alerter » au lieu d'ajouter quand la variante est épuisée ; « Acheter maintenant » */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    const btn = $('[data-add-button]', form);
    const submitter = e.submitter;
    if (btn && btn.dataset.mode === 'notify' && (!submitter || submitter === btn)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openRestock(form.closest('product-info') || document);
    }
  }, true);

  /* ---------- Galerie : glisser, vignettes, flèches, zoom au survol, visionneuse plein écran ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      if (!this.track) return;
      this.slides = $$('.gallery__slide', this);
      this.thumbs = $$('[data-thumb]', this);
      this.counter = $('[data-gallery-current]', this);
      this.total = $('[data-gallery-total]', this);
      this.status = $('[data-gallery-status]', this);
      this.index = Math.max(0, Number(this.dataset.start || 0));
      this.track.addEventListener('scroll', debounce(() => this.onScroll(), 80), { passive: true });
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.thumb), true)));
      const prev = $('[data-gallery-prev]', this);
      const next = $('[data-gallery-next]', this);
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));
      this.addEventListener('keydown', (e) => {
        if (e.target.closest('dialog') || !e.target.closest('.gallery__main')) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1, true); }
      });
      if (this.index > 0) requestAnimationFrame(() => this.goTo(this.index, false, true));
      this.initHoverZoom();
      this.initLightbox();
      this.initDeferred();
    }
    /* Autres images de la galerie : chargées une fois la page chargée, ou dès que le visiteur touche la galerie */
    initDeferred() {
      if (!$('img[data-src]', this)) return;
      const go = () => this.loadDeferred();
      ['pointerdown', 'focusin', 'keydown', 'wheel'].forEach((t) => this.addEventListener(t, go, { once: true, passive: true }));
      this.track.addEventListener('scroll', go, { once: true, passive: true });
      const later = () => (window.requestIdleCallback ? requestIdleCallback(go, { timeout: 1500 }) : setTimeout(go, 200));
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    }
    loadDeferred() {
      $$('img[data-src]', this).forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      });
    }
    visible() { return this.slides.filter((s) => !s.hidden); }
    step(dir, focus) {
      const vis = this.visible();
      if (vis.length < 2) return;
      const pos = Math.max(0, vis.indexOf(this.slides[this.index]));
      const target = vis[(pos + dir + vis.length) % vis.length];
      this.goTo(this.slides.indexOf(target), true);
      if (focus) { const z = $('.gallery__zoom', target); if (z) z.focus({ preventScroll: true }); }
    }
    goTo(index, announce, instant) {
      const slide = this.slides[index];
      if (!slide || slide.hidden) return;
      this.loadDeferred();
      this.track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : smooth() });
      this.setActive(index, announce);
    }
    goToMedia(id) {
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i > -1) this.goTo(i);
    }
    onScroll() {
      const x = this.track.scrollLeft;
      let best = this.index;
      let dist = Infinity;
      this.visible().forEach((s) => {
        const d = Math.abs(s.offsetLeft - x);
        if (d < dist) { dist = d; best = this.slides.indexOf(s); }
      });
      if (best !== this.index) this.setActive(best, false);
    }
    setActive(index, announce) {
      this.index = index;
      const vis = this.visible();
      const pos = vis.indexOf(this.slides[index]) + 1;
      this.slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index);
        /* Un seul bouton « Agrandir » dans l'ordre de tabulation : celui de l'image affichée */
        const z = s.querySelector('.gallery__zoom');
        if (z) z.tabIndex = i === index ? 0 : -1;
      });
      this.thumbs.forEach((t) => {
        const on = Number(t.dataset.thumb) === index;
        t.classList.toggle('is-active', on);
        if (on) {
          t.setAttribute('aria-current', 'true');
          const list = t.closest('.gallery__thumbs');
          if (list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.offsetLeft - list.clientWidth / 2 + t.clientWidth / 2, behavior: smooth() });
        } else t.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = pos;
      if (this.total) this.total.textContent = vis.length;
      if (announce && this.status) this.status.textContent = fill(S.galleryPosition, { current: pos, total: vis.length });
    }
    /* Variante choisie : son image, et (option) seules ses images et les images communes */
    showVariant(v) {
      if (this.hasAttribute('data-variant-images')) {
        const keep = (el) => !el.hasAttribute('data-variant-media') || el.dataset.mediaId === String(v.media);
        let shown = 0;
        this.slides.forEach((s) => { s.hidden = !keep(s); if (!s.hidden) shown += 1; });
        $$('[data-thumb-item]', this).forEach((li) => { li.hidden = !keep(li); });
        if (!shown) { this.slides.forEach((s) => { s.hidden = false; }); $$('[data-thumb-item]', this).forEach((li) => { li.hidden = false; }); }
      }
      if (v.media) this.goToMedia(v.media);
      else { const first = this.visible()[0]; if (first) this.goTo(this.slides.indexOf(first)); }
    }
    initHoverZoom() {
      if (this.dataset.zoom !== 'hover' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      $$('.gallery__zoom', this).forEach((z) => {
        const img = $('.gallery__img', z);
        if (!img) return;
        z.addEventListener('pointermove', (e) => {
          const r = z.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          z.classList.add('is-zooming');
        });
        z.addEventListener('pointerleave', () => { z.classList.remove('is-zooming'); img.style.transformOrigin = ''; });
      });
    }
    initLightbox() {
      this.dialog = $('[data-lightbox]', this);
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.lbImg = $('[data-lightbox-img]', this.dialog);
      this.lbStage = $('[data-lightbox-stage]', this.dialog);
      this.lbCount = $('[data-lightbox-count]', this.dialog);
      this.lbZoom = $('[data-lightbox-zoom]', this.dialog);
      this.addEventListener('click', (e) => {
        const z = e.target.closest('[data-zoom-src]');
        if (!z || z.closest('dialog')) return;
        this.openLightbox(Number(z.dataset.zoomIndex));
      });
      $('[data-lightbox-close]', this.dialog).addEventListener('click', () => this.dialog.close());
      const prev = $('[data-lightbox-prev]', this.dialog);
      const next = $('[data-lightbox-next]', this.dialog);
      if (prev) prev.addEventListener('click', () => this.lbStep(-1));
      if (next) next.addEventListener('click', () => this.lbStep(1));
      if (this.lbZoom) this.lbZoom.addEventListener('click', () => this.setZoom(!this.zoomed));
      this.lbStage.addEventListener('click', (e) => {
        if (this.dragged) return;
        if (e.target === this.lbImg) this.setZoom(!this.zoomed, e);
        else if (e.target === this.lbStage) this.dialog.close();
      });
      this.lbStage.addEventListener('pointermove', (e) => { if (this.zoomed) { this.pan(e); if (this.sx !== null && Math.abs(e.clientX - this.sx) > 6) this.dragged = true; } });
      this.sx = null;
      this.lbStage.addEventListener('pointerdown', (e) => { this.sx = e.clientX; this.dragged = false; });
      this.lbStage.addEventListener('pointerup', (e) => {
        if (this.sx !== null && !this.zoomed && Math.abs(e.clientX - this.sx) > 50) { this.dragged = true; this.lbStep(e.clientX < this.sx ? 1 : -1); }
        this.sx = null;
        setTimeout(() => { this.dragged = false; }, 0);
      });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.lbStep(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.lbStep(-1); }
      });
      this.dialog.addEventListener('close', () => {
        this.setZoom(false);
        document.body.classList.remove('has-overlay');
        if (this.lbOpener && this.lbOpener.focus) this.lbOpener.focus({ preventScroll: true });
      });
    }
    lbSlides() { return this.visible().filter((s) => $('[data-zoom-src]', s)); }
    openLightbox(index) {
      this.lbOpener = document.activeElement;
      this.lbIndex = index;
      this.showLb();
      this.dialog.showModal();
      document.body.classList.add('has-overlay');
    }
    showLb() {
      const list = this.lbSlides();
      const slide = this.slides[this.lbIndex];
      const btn = slide && $('[data-zoom-src]', slide);
      if (!btn) return;
      this.setZoom(false);
      this.lbImg.src = btn.dataset.zoomSrc;
      this.lbImg.alt = ($('img', btn) || {}).alt || '';
      if (this.lbCount) this.lbCount.textContent = fill(S.galleryPosition, { current: list.indexOf(slide) + 1, total: list.length });
    }
    lbStep(dir) {
      const list = this.lbSlides();
      if (list.length < 2) return;
      const pos = Math.max(0, list.indexOf(this.slides[this.lbIndex]));
      const target = list[(pos + dir + list.length) % list.length];
      this.lbIndex = this.slides.indexOf(target);
      this.showLb();
      this.goTo(this.lbIndex, false, true);
    }
    setZoom(on, e) {
      this.zoomed = !!on;
      if (!this.lbStage) return;
      this.lbStage.classList.toggle('is-zoomed', this.zoomed);
      if (this.lbZoom) {
        this.lbZoom.setAttribute('aria-pressed', this.zoomed ? 'true' : 'false');
        this.lbZoom.setAttribute('aria-label', this.zoomed ? this.lbZoom.dataset.labelOut : this.lbZoom.dataset.labelIn);
      }
      if (this.zoomed && e) this.pan(e);
      if (!this.zoomed) this.lbImg.style.transformOrigin = '';
    }
    pan(e) {
      const r = this.lbStage.getBoundingClientRect();
      const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      this.lbImg.style.transformOrigin = `${x}% ${y}%`;
    }
  }
  if (!customElements.get('media-gallery')) customElements.define('media-gallery', MediaGallery);

  /* ---------- Onglets : accordéon accessible, onglets sur ordinateur en option ---------- */
  class PLTabs extends HTMLElement {
    connectedCallback() {
      this.items = $$('[data-tab-item]', this);
      this.triggers = this.items.map((it) => $('.product-tabs__trigger', it));
      this.panels = this.items.map((it) => $('.product-tabs__panel', it));
      this.triggers.forEach((btn, i) => btn.addEventListener('click', () => this.toggle(i)));
      this.addEventListener('keydown', (e) => this.onKey(e));
      this.useTabs = this.dataset.style === 'tabs';
      this.mq = window.matchMedia('(min-width: 990px)');
      if (this.useTabs) {
        this.mq.addEventListener('change', () => this.mode());
        this.mode();
      }
    }
    toggle(i, force) {
      const btn = this.triggers[i];
      const open = force !== undefined ? force : btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.panels[i].hidden = !open;
    }
    open(i) { if (this.tabbed) this.select(i); else this.toggle(i, true); }
    indexOf(el) { return this.items.findIndex((it) => it.contains(el)); }
    mode(force) {
      const tabs = this.useTabs && this.mq.matches;
      if (tabs === this.tabbed && !force) return;
      this.tabbed = tabs;
      if (this.list) { this.list.remove(); this.list = null; }
      this.classList.toggle('is-tabbed', tabs);
      if (tabs) {
        const shown = this.items.map((it, i) => (it.hidden ? -1 : i)).filter((i) => i > -1);
        this.list = document.createElement('div');
        this.list.className = 'product-tabs__list';
        this.list.setAttribute('role', 'tablist');
        this.tabBtns = [];
        shown.forEach((i) => {
          const t = document.createElement('button');
          t.type = 'button';
          t.className = 'product-tabs__tab';
          t.id = `${this.triggers[i].id}-tab`;
          t.setAttribute('role', 'tab');
          t.setAttribute('aria-controls', this.panels[i].id);
          t.dataset.index = i;
          t.textContent = ($('.product-tabs__title', this.triggers[i]) || this.triggers[i]).textContent;
          t.addEventListener('click', () => this.select(i, true));
          this.list.appendChild(t);
          this.tabBtns[i] = t;
          this.panels[i].setAttribute('role', 'tabpanel');
          this.panels[i].setAttribute('aria-labelledby', t.id);
          this.panels[i].tabIndex = 0;
        });
        this.prepend(this.list);
        const opened = shown.find((i) => this.triggers[i].getAttribute('aria-expanded') === 'true');
        this.select(opened !== undefined ? opened : shown[0]);
      } else {
        this.panels.forEach((p, i) => {
          p.setAttribute('role', 'region');
          p.setAttribute('aria-labelledby', this.triggers[i].id);
          p.removeAttribute('tabindex');
          p.hidden = this.triggers[i].getAttribute('aria-expanded') !== 'true';
        });
      }
    }
    select(i, focus) {
      if (i === undefined) return;
      this.items.forEach((it, k) => {
        const on = k === i;
        const t = this.tabBtns[k];
        if (t) { t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; }
        this.panels[k].hidden = !on;
        this.triggers[k].setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      if (focus && this.tabBtns[i]) this.tabBtns[i].focus();
    }
    refresh() { if (this.tabbed) this.mode(true); }
    onKey(e) {
      if (!this.tabbed || e.target.getAttribute('role') !== 'tab') return;
      const order = this.tabBtns.map((t, i) => (t ? i : -1)).filter((i) => i > -1);
      const pos = order.indexOf(Number(e.target.dataset.index));
      let next = null;
      if (e.key === 'ArrowRight') next = order[(pos + 1) % order.length];
      if (e.key === 'ArrowLeft') next = order[(pos - 1 + order.length) % order.length];
      if (e.key === 'Home') next = order[0];
      if (e.key === 'End') next = order[order.length - 1];
      if (next !== null) { e.preventDefault(); this.select(next, true); }
    }
  }
  if (!customElements.get('pl-tabs')) customElements.define('pl-tabs', PLTabs);

  /* ---------- Recommandations produit (chargées à l'approche) ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.children.length && $('.slider', this)) return;
      const load = () => {
        fetch(this.dataset.url).then((r) => r.text()).then((html) => {
          const fresh = $('product-recommendations', parseHTML(html));
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          initWishlistButtons(this);
        }).catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else load();
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Barre d'achat collante ---------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      if (!this.info || !('IntersectionObserver' in window)) return;
      this.main = $('[data-add-button]', this.info);
      if (!this.main) return;
      this.btn = $('[data-sticky-add]', this);
      this.label = $('[data-sticky-label]', this);
      this.price = $('[data-sticky-price]', this);
      this.variant = $('[data-sticky-variant]', this);
      this.img = $('.sticky-atc__img', this);
      this.desktop = this.classList.contains('sticky-atc--desktop');
      // La barre s'affiche dès que le bouton principal n'est pas entièrement visible : sous l'écran, à moitié caché par la barre du bas
      // sur téléphone, comme après l'avoir dépassé, pour que « Ajouter au panier » soit toujours à portée ; ordinateur : si l'option est activée
      // (pas de barre du bas sur ordinateur : marge de 8 px au lieu de 88 px)
      const margin = isDesktop() ? 8 : 88;
      this.io = new IntersectionObserver(([en]) => this.toggle(en.intersectionRatio < 0.99 && (en.boundingClientRect.top < 0 || !isDesktop() || this.desktop)), { rootMargin: `0px 0px -${margin}px 0px`, threshold: [0, 0.99] });
      this.io.observe(this.main);
      this.btn.addEventListener('click', () => this.onClick());
      this.info.addEventListener('variant:change', (e) => this.update(e.detail));
      document.addEventListener('cart:updated', () => this.btn.classList.remove('is-loading'));
    }
    toggle(show) {
      const on = show && (this.desktop || !isDesktop());
      this.hidden = !on;
      document.body.classList.toggle('has-sticky-atc', on);
    }
    onClick() {
      if (this.btn.dataset.mode === 'notify') { openRestock(this.info); return; }
      if (this.main.disabled) { this.main.scrollIntoView({ behavior: smooth(), block: 'center' }); return; }
      const form = this.main.form;
      if (form && form.requestSubmit) form.requestSubmit(this.main); else this.main.click();
    }
    update(v) {
      if (!v) return;
      if (this.price) this.price.textContent = formatMoney(v.price);
      if (this.variant) this.variant.textContent = v.title;
      setMode(this.btn, this.label, modeFor(this.info, v));
      if (this.img && v.media) {
        const pick = (img) => img && (img.dataset.src || img.currentSrc || img.src);
        const src = pick($(`[data-thumb-item][data-media-id="${v.media}"] img`, this.info)) || pick($(`.gallery__slide[data-media-id="${v.media}"] img`, this.info));
        if (src) {
          this.img.removeAttribute('srcset');
          this.img.src = src;
        }
      }
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  /* ---------- Livraison estimée : recalcul dans le navigateur (mêmes règles que snippets/product-delivery) ---------- */
  const updateDelivery = (el) => {
    let c;
    try { c = JSON.parse(el.dataset.config); } catch (e) { return; }
    const days = String(el.dataset.days || '').split(',');
    const months = String(el.dataset.months || '').split(',');
    const fmt = (d) => String(el.dataset.pattern || '[day] [d] [month]').replace('[day]', days[d.getUTCDay()] || '').replace('[month]', months[d.getUTCMonth()] || '').replace('[d]', d.getUTCDate());
    const ymd = (d) => d.toISOString().slice(0, 10);
    const hol = new Set(c.hol || []);
    const now = new Date(Date.now() + Number(c.off || 0) * 60000);
    const day = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 12));
    const ship = new Date(day.getTime());
    if (now.getUTCHours() >= c.cutoff) ship.setUTCDate(ship.getUTCDate() + 1);
    let need = Number(c.prep || 0);
    for (let i = 0; i < 40; i += 1) {
      const w = ship.getUTCDay();
      const ok = w !== 0 && !(w === 6 && !c.shipSat) && !hol.has(ymd(ship));
      if (ok) { if (need <= 0) break; need -= 1; }
      ship.setUTCDate(ship.getUTCDate() + 1);
    }
    const d = new Date(ship.getTime());
    let n = 0;
    let start = new Date(ship.getTime());
    let end = new Date(ship.getTime());
    for (let i = 0; i < 40; i += 1) {
      d.setUTCDate(d.getUTCDate() + 1);
      const w = d.getUTCDay();
      if (w === 0 || hol.has(ymd(d)) || (w === 6 && !c.delSat)) continue;
      n += 1;
      if (n === c.min) start = new Date(d.getTime());
      if (n >= c.max) { end = new Date(d.getTime()); break; }
    }
    const tomorrow = start.getTime() === end.getTime() && start.getTime() - day.getTime() === 86400000 && el.dataset.tplTomorrow;
    const range = tomorrow
      ? fill(el.dataset.tplTomorrow, { date: fmt(start) })
      : start.getTime() === end.getTime()
        ? fill(el.dataset.tplSingle, { date: fmt(start) })
        : fill(el.dataset.tplRange, { start: fmt(start), end: fmt(end) });
    const today = ship.getTime() === day.getTime();
    const time = String(el.dataset.timePattern || '[h]:[m]').replace('[h]', c.cutoff).replace('[m]', '00');
    let cut = today ? fill(el.dataset.tplToday, { time }) : fill(el.dataset.tplShips, { date: fmt(ship) });
    if (today && el.dataset.tplCountdown) {
      // Temps restant avant l'heure limite, à la minute près (« Commandez dans 2 h 15 min… »)
      const left = c.cutoff * 60 - (now.getUTCHours() * 60 + now.getUTCMinutes());
      const h = Math.floor(left / 60);
      const dur = h > 0 ? fill(el.dataset.durHm, { h, m: left % 60 }) : fill(el.dataset.durM, { m: left % 60 });
      cut = fill(el.dataset.tplCountdown, { time: dur, cutoff: time });
    }
    const r = $('[data-delivery-range]', el);
    const k = $('[data-delivery-cutoff]', el);
    if (r && range) r.textContent = range;
    if (k && cut) k.textContent = cut;
    // Frise : expédition (« Aujourd'hui » ou date) et livraison en dates courtes (« 29–30 oct. »)
    const sh = $('[data-delivery-ship]', el);
    const eta = $('[data-delivery-eta]', el);
    if (sh) {
      sh.textContent = today ? el.dataset.today : fmt(ship);
      const step = sh.closest('.delivery__step');
      if (step && el.classList.contains('delivery-flow')) step.classList.toggle('is-done', today);
    }
    if (eta) {
      const short = (d) => String(el.dataset.patternShort || '[d] [month]').replace('[month]', months[d.getUTCMonth()] || '').replace('[d]', d.getUTCDate());
      let txt = short(start);
      if (start.getTime() !== end.getTime()) {
        txt = start.getUTCMonth() === end.getUTCMonth()
          ? fill(el.dataset.tplEtaMonth, { d1: start.getUTCDate(), d2: end.getUTCDate(), month: months[start.getUTCMonth()] || '' })
          : fill(el.dataset.tplEta, { start: short(start), end: short(end) });
      }
      eta.textContent = txt;
    }
  };
  $$('[data-delivery]').forEach(updateDelivery);
  setInterval(() => $$('[data-delivery]').forEach(updateDelivery), 60000);

  /* Choix du transporteur : la carte sélectionnée affiche sa frise (toutes les copies du bloc restent synchronisées) */
  document.addEventListener('click', (e) => {
    const pick = e.target.closest('[data-carrier-pick]');
    if (!pick) return;
    const c = pick.dataset.carrierPick;
    $$('.reassurance').forEach((box) => {
      if (!$(`[data-flow-carrier="${c}"]`, box)) return;
      $$('[data-flow-carrier]', box).forEach((p) => p.classList.toggle('is-active', p.dataset.flowCarrier === c));
      $$('[data-carrier-pick]', box).forEach((b) => {
        const on = b.dataset.carrierPick === c;
        b.setAttribute('aria-pressed', String(on));
        b.closest('.delivery-opt').classList.toggle('is-selected', on);
      });
    });
  });

  /* Livraison express : montant minimum de commande, reste à ajouter et jauge d'après le panier (page en cache : panier relu au chargement) */
  const updateExpressMin = (total) => {
    $$('[data-express][data-min]').forEach((el) => {
      const min = Number(el.dataset.min || 0);
      const box = $('[data-express-min]', el);
      if (!min || !box) return;
      const t = Math.max(0, Number(total) || 0);
      const left = min - t;
      const text = $('[data-express-min-text]', box);
      if (text) text.textContent = left <= 0 ? el.dataset.tplOk : fill(el.dataset.tplLeft, { amount: formatMoney(left) });
      const meter = $('[data-express-meter]', box);
      if (meter) meter.style.width = `${Math.min(100, Math.round((t / min) * 100))}%`;
      box.classList.toggle('is-reached', left <= 0);
      box.hidden = t <= 0;
      el.dataset.cart = t;
    });
  };
  if ($('[data-express][data-min]')) {
    fetch(`${PL.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => updateExpressMin(c.total_price)).catch(() => {});
    ['cart:updated', 'cart:changed'].forEach((ev) => document.addEventListener(ev, (e) => {
      if (e.detail && typeof e.detail.total_price === 'number') updateExpressMin(e.detail.total_price);
    }));
  }

  /* ---------- Avis : ouvrir l'onglet depuis les étoiles, « voir plus », tri ---------- */
  const openReviews = (info) => {
    const trigger = $('[data-tab-reviews]', info);
    const tabs = trigger && trigger.closest('pl-tabs');
    if (tabs && tabs.open) tabs.open(tabs.indexOf(trigger));
    const target = $('[data-reviews]', info) || trigger;
    if (target) target.scrollIntoView({ behavior: smooth(), block: 'start' });
  };
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-open-reviews]');
    if (link) {
      e.preventDefault();
      openReviews(link.closest('product-info') || document);
      return;
    }
    const more = e.target.closest('[data-reviews-more]');
    if (more) {
      const box = more.closest('[data-reviews]');
      $$('[data-review-more]', box).forEach((li) => { li.hidden = false; });
      box.dataset.expanded = '1';
      more.remove();
    }
  });

  /* Tri des avis (plus récents, plus anciens, mieux notés, moins bien notés) ; les 5 premiers restent visibles tant que « Voir plus » n'a pas été utilisé */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-reviews-sort]');
    if (!sel) return;
    const box = sel.closest('[data-reviews]');
    const list = $('[data-reviews-list]', box);
    if (!list) return;
    const items = $$('.review', list);
    const date = (li) => li.dataset.date || '';
    const note = (li) => Number(li.dataset.note || 0);
    const order = (li) => Number(li.dataset.order || 0);
    const cmp = {
      recent: (a, b) => date(b).localeCompare(date(a)) || order(a) - order(b),
      oldest: (a, b) => date(a).localeCompare(date(b)) || order(b) - order(a),
      best: (a, b) => note(b) - note(a) || date(b).localeCompare(date(a)),
      worst: (a, b) => note(a) - note(b) || date(b).localeCompare(date(a))
    }[sel.value] || (() => 0);
    items.sort(cmp).forEach((li, i) => {
      list.appendChild(li);
      if (!box.dataset.expanded && $('[data-reviews-more]', box)) li.hidden = i >= 5;
    });
  });

  /* ---------- Avis publiés immédiatement ----------
     Si le formulaire porte une adresse de serveur (data-review-endpoint), l'avis est envoyé en arrière-plan,
     publié dans le métachamp avis.liste et ajouté tout de suite à la liste. Il est aussi gardé 2 h dans le navigateur
     pour rester affiché si la page (mise en cache par Shopify) est rechargée avant sa mise à jour. */
  const PENDING_KEY = 'pl_reviews_pending';
  const PENDING_TTL = 2 * 3600e3;
  const reviewItem = (r, form) => {
    const verified = r.verifie ? `<span class="review__verified">✓ ${esc(form.dataset.reviewVerified || '')}</span>` : '';
    const title = r.titre ? `<p class="review__title">${esc(r.titre)}</p>` : '';
    return `<li class="review review--new" data-review-id="${esc(r.id)}" data-note="${Number(r.note) || 0}" data-date="${esc(r.date || '')}" data-order="0"><div class="review__head">`
      + `<span class="review__avatar" aria-hidden="true">${esc(String(r.nom || '?').charAt(0).toUpperCase())}</span>`
      + `<div class="review__who"><strong>${esc(r.nom)}</strong><span class="review__meta"><time datetime="${esc(r.date)}">${esc(form.dataset.reviewJustNow || r.date)}</time>${verified}</span></div>`
      + `<div class="rating review__stars" role="img" aria-label="${Number(r.note)}/5">${starsHTML(Number(r.note))}</div></div>`
      + `${r.variante ? `<span class="review__variant">${esc(form.dataset.reviewOption || '')} : ${esc(r.variante)}</span>` : ''}`
      + `${title}<p class="review__text">${esc(r.texte).replace(/\n/g, '<br>')}</p></li>`;
  };
  const showReview = (r, form) => {
    const box = form.closest('[data-reviews]');
    if (!box || $(`[data-review-id="${CSS.escape(r.id)}"]`, box)) return;
    let list = $('.reviews__list', box);
    if (!list) {
      list = document.createElement('ul');
      list.className = 'reviews__list';
      const empty = $('[data-reviews-empty]', box);
      const summary = $('.reviews__summary', box);
      if (empty) empty.replaceWith(list);
      else if (summary) summary.after(list);
      else box.prepend(list);
    }
    list.insertAdjacentHTML('afterbegin', reviewItem(r, form));
    const count = Number(box.dataset.reviewsCount || 0) + 1;
    box.dataset.reviewsCount = count;
    const info = box.closest('product-info') || document;
    const trigger = $('[data-tab-reviews]', info);
    const targets = [];
    if (trigger) {
      targets.push($('.product-tabs__title', trigger));
      targets.push($(`#${CSS.escape(trigger.id)}-tab`, info));
    }
    targets.forEach((el) => { if (el) el.textContent = el.textContent.replace(/\(\d+\)\s*$/, `(${count})`); });
  };
  const pending = () => {
    const now = Date.now();
    const all = storage.get(PENDING_KEY, []);
    return Array.isArray(all) ? all.filter((p) => p && p.r && now - p.at < PENDING_TTL) : [];
  };
  $$('form[data-review-handle]').forEach((form) => {
    const handle = form.dataset.reviewHandle;
    if (!handle) return;
    form.dataset.openedAt = Date.now();
    pending().filter((p) => p.h === handle).forEach((p) => showReview(p.r, form));
  });

  /* Formulaires « avis » et « retour en stock » : sans serveur, ils passent par le formulaire de contact de Shopify (page rechargée).
     On mémorise le formulaire envoyé pour afficher le bon message de confirmation au retour. */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-pl-form]');
    if (!form) return;
    const endpoint = form.dataset.reviewEndpoint;
    const handle = form.dataset.reviewHandle;
    if (form.dataset.plForm !== 'review' || !endpoint || !handle || form.dataset.fallback) {
      storage.set('pl_form_sent', form.getAttribute('data-pl-form'));
      return;
    }
    e.preventDefault();
    const fd = new FormData(form);
    const btn = $('[data-review-submit]', form);
    const err = $('[data-review-error]', form.parentElement);
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.sending || label; }
    if (err) err.hidden = true;
    const body = {
      handle,
      nom: fd.get('contact[name]'),
      email: fd.get('contact[email]'),
      note: parseInt(String(fd.get('contact[Note]') || ''), 10),
      titre: fd.get('contact[Titre]') || '',
      texte: fd.get('contact[body]'),
      variante: fd.get('contact[Variante]') || '',
      consent: fd.get('contact[Consentement publication]') === 'oui',
      website: fd.get('website') || '',
      t: Date.now() - Number(form.dataset.openedAt || Date.now())
    };
    try {
      const res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.review) {
        if (res.status >= 500) throw new Error('server');
        if (err) { err.textContent = data.error || err.textContent; err.hidden = false; }
        return;
      }
      storage.set(PENDING_KEY, [...pending(), { h: handle, at: Date.now(), r: data.review }]);
      showReview(data.review, form);
      form.reset();
      form.hidden = true;
      const thanks = $('[data-review-thanks]', form.parentElement);
      if (thanks) thanks.hidden = false;
      const first = $('.reviews__list .review', form.closest('[data-reviews]'));
      if (first) first.scrollIntoView({ behavior: smooth(), block: 'center' });
    } catch (x) {
      // Serveur injoignable : l'avis part par e-mail à la boutique (formulaire de contact classique)
      form.dataset.fallback = '1';
      storage.set('pl_form_sent', 'review');
      form.submit();
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });
  (() => {
    const sent = storage.get('pl_form_sent');
    if (!sent || !/contact_posted=true/.test(window.location.search)) return;
    storage.set('pl_form_sent', null);
    if (sent === 'review') {
      const thanks = $('[data-review-thanks]');
      const details = $('[data-review-write]');
      if (thanks && details) {
        details.open = true;
        thanks.hidden = false;
        const form = $('.reviews__form', details);
        if (form) form.hidden = true;
        openReviews(details.closest('product-info') || document);
      }
    } else if (sent === 'restock') {
      const thanks = $('[data-restock-thanks]');
      if (thanks) {
        thanks.hidden = false;
        const box = thanks.closest('[data-restock]');
        if (box) { box.hidden = false; const f = $('form', box); if (f) f.hidden = true; }
      }
    }
  })();

  /* ---------- « Souvent achetés ensemble » : sélection, total, ajout groupé, recommandations Shopify en complément ---------- */
  /* Saveur et dosage normalisés : mêmes règles que snippets/text-norm et snippets/nic-mg */
  const normText = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/œ/g, 'oe')
    .replace(/[-_/,.()&'’+|]/g, ' ').replace(/\s+/g, ' ').trim();
  const nicOf = (s) => {
    const v = String(s || '').toLowerCase().replace(/,/g, '.').replace(/\s/g, '');
    if (/sansnic|nicotinefree/.test(v)) return '0';
    const m = v.match(/^(\d+(?:\.\d+)?)(%|mg)/);
    if (!m) return '';
    return m[2] === '%' ? String(Math.round(parseFloat(m[1]) * 10)) : String(parseFloat(m[1]));
  };
  const baseFlavor = (f) => {
    const b = ` ${f} `.replace(/ (ice|iced|glace|glacee|frost|freeze|fresh|frais) /g, ' ').trim();
    return b !== f && b.length >= 4 ? b : '';
  };
  class PLBundle extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info') || document;
      this.btn = $('[data-bundle-add]', this);
      this.addEventListener('change', () => this.update());
      this.addEventListener('click', (e) => { if (e.target.closest('[data-bundle-add]')) this.add(); });
      /* Variante affichée au chargement : épuisée ou bloquée (dosage) → ajout de la sélection désactivé */
      const idInput = $('form [data-variant-id]', this.info) || $('[data-variant-id]', this.info);
      const cur = idInput && variantsOf(this.info === document ? null : this.info).find((v) => String(v.id) === String(idInput.value));
      this.mainOut = cur ? !cur.available : !!(this.btn && this.btn.disabled);
      const fi = Number(this.dataset.flavorIndex);
      if (cur && fi >= 0) this.flavor = normText(cur.options[fi]);
      this.update();
      if (this.dataset.recosUrl) this.recos();
    }
    items() { return $$('[data-bundle-item]', this); }
    priceOf(item) {
      const v = $('[data-bundle-variant]', item);
      if (!v) return 0;
      if (v.tagName === 'SELECT') { const o = v.options[v.selectedIndex]; return Number(o ? o.dataset.price : 0); }
      return Number(v.dataset.price || 0);
    }
    update() {
      const main = $('[data-bundle-main-price]', this);
      let cents = Number(main ? main.dataset.price : 0);
      let count = 1;
      this.items().forEach((it) => {
        const p = this.priceOf(it);
        const priceEl = $('[data-bundle-item-price]', it);
        if (priceEl) priceEl.textContent = formatMoney(p);
        const c = $('[data-bundle-check]', it);
        if (c && c.checked) { cents += p; count += 1; }
      });
      const total = $('[data-bundle-total]', this);
      if (total) total.textContent = formatMoney(cents);
      const label = $('[data-bundle-count]', this);
      if (label) label.textContent = count === 1 ? this.dataset.labelOne : String(this.dataset.labelOther || '').replace('7777', count);
      const addLabel = $('[data-bundle-add-label]', this);
      if (addLabel && this.dataset.labelAddOther) addLabel.textContent = count === 1 ? this.dataset.labelAddOne : String(this.dataset.labelAddOther).replace('7777', count);
      if (this.btn) this.btn.disabled = !!this.mainOut;
    }
    /* Variante du produit changée : chaque complément passe à la variante la plus proche (même saveur, même dosage) */
    syncTo(v) {
      const fi = Number(this.dataset.flavorIndex);
      const ni = Number(this.dataset.nicIndex);
      const flavor = fi >= 0 ? normText(v.options[fi]) : '';
      const nic = ni >= 0 ? nicOf(v.options[ni]) : '';
      if (!flavor && !nic) return;
      const base = baseFlavor(flavor);
      $$('select[data-bundle-variant]', this).forEach((sel) => {
        let best = null;
        let bestScore = 0;
        Array.from(sel.options).forEach((o) => {
          let sc = 0;
          const of = o.dataset.flavor || '';
          if (flavor && of) {
            if (of === flavor) sc += 4;
            else if (base && ` ${of} `.includes(` ${base} `)) sc += 2;
          }
          if (nic && o.dataset.nic === nic) sc += 1;
          if (sc > bestScore) { bestScore = sc; best = o; }
        });
        /* Une saveur voulue mais absente du complément : sa sélection reste celle du visiteur */
        if (best && !best.selected && (!flavor || !$('option[data-flavor]', sel) || bestScore >= 2)) sel.value = best.value;
      });
    }
    setMain(v) {
      const main = $('[data-bundle-main-price]', this);
      if (main) { main.dataset.price = v.price; main.textContent = formatMoney(v.price); }
      const title = $('[data-bundle-main-variant]', this);
      if (title) title.textContent = v.title;
      this.syncTo(v);
      this.mainOut = !v.available;
      this.update();
      /* Autre saveur : les compléments choisis d'après la saveur (e-liquide de la même saveur…) sont recalculés par le thème */
      const fi = Number(this.dataset.flavorIndex);
      const flavor = fi >= 0 ? normText(v.options[fi]) : '';
      if (fi >= 0 && this.flavor !== undefined && flavor !== this.flavor) this.reload(v);
      this.flavor = flavor;
    }
    async reload(v) {
      const info = this.info;
      if (!info || !info.dataset || !info.dataset.url || !info.dataset.sectionId) return;
      const token = (this.token || 0) + 1;
      this.token = token;
      this.classList.add('is-loading');
      try {
        const res = await fetch(`${info.dataset.url}?variant=${v.id}&section_id=${encodeURIComponent(info.dataset.sectionId)}`);
        if (!res.ok || token !== this.token) return;
        const fresh = $('pl-bundle', parseHTML(await res.text()));
        if (!fresh || token !== this.token) return;
        ['recosUrl', 'bundlePending'].forEach((k) => { if (!(k in fresh.dataset)) delete this.dataset[k]; });
        Object.assign(this.dataset, fresh.dataset);
        this.hidden = fresh.hidden;
        this.innerHTML = fresh.innerHTML;
        this.btn = $('[data-bundle-add]', this);
        this.update();
        if (this.dataset.recosUrl) this.recos();
      } catch (e) { /* hors ligne : la sélection actuelle reste affichée */ }
      finally { if (token === this.token) this.classList.remove('is-loading'); }
    }
    async add() {
      const idInput = $('form [data-variant-id]', this.info) || $('[data-variant-id]', this.info);
      const items = [];
      if (idInput && idInput.value) items.push({ id: Number(idInput.value), quantity: 1 });
      this.items().forEach((it) => {
        const c = $('[data-bundle-check]', it);
        const v = $('[data-bundle-variant]', it);
        if (c && c.checked && v && v.value) items.push({ id: Number(v.value), quantity: 1 });
      });
      if (!items.length || this.btn.classList.contains('is-loading')) return;
      this.btn.classList.add('is-loading');
      try { await Cart.add(items, this.btn); }
      catch (err) { toast(err.message || S.error, 'error'); }
      finally { this.btn.classList.remove('is-loading'); }
    }
    recos() {
      const limit = Number(this.dataset.limit || 2);
      const run = async () => {
        if (this.items().length >= limit) return;
        try {
          const res = await fetch(this.dataset.recosUrl);
          if (!res.ok) return;
          const doc = parseHTML(await res.text());
          const have = new Set(this.items().map((it) => it.dataset.productId));
          const mainId = this.info.dataset ? this.info.dataset.productId : '';
          const list = $('[data-bundle-items]', this);
          $$('[data-bundle-recos] [data-bundle-item]', doc).forEach((li) => {
            if (this.items().length >= limit || have.has(li.dataset.productId) || li.dataset.productId === mainId) return;
            list.appendChild(document.importNode(li, true));
            have.add(li.dataset.productId);
          });
          if (!this.items().length) return;
          this.hidden = false;
          this.removeAttribute('data-bundle-pending');
          const tab = this.closest('[data-tab-item]');
          if (tab && tab.hidden) {
            tab.hidden = false;
            const tabs = tab.closest('pl-tabs');
            if (tabs && tabs.refresh) tabs.refresh();
          }
          this.update();
        } catch (e) { /* recommandations indisponibles : la sélection reste celle du thème */ }
      };
      if (this.hasAttribute('data-bundle-pending') || !('IntersectionObserver' in window)) { run(); return; }
      const io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { io.disconnect(); run(); } }, { rootMargin: '0px 0px 300px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('pl-bundle')) customElements.define('pl-bundle', PLBundle);

  /* ---------- « Même saveur, autre marque » (sections/same-flavor) ---------- */
  class SameFlavor extends HTMLElement {
    connectedCallback() {
      this.info = $('product-info[data-handle]');
      this.track = $('[data-same-track]', this);
      if (!this.track) return;
      this.load(this.dataset.flavor);
      if (this.info && this.dataset.option !== '') {
        this.info.addEventListener('variant:change', (e) => {
          const i = Number(this.dataset.option);
          const v = e.detail;
          if (!v || Number.isNaN(i) || !v.options[i] || v.options[i] === this.current) return;
          this.load(v.options[i]);
        });
      }
    }
    async load(flavor) {
      const term = String(flavor || '').trim();
      this.current = term;
      if (!term) { this.hidden = true; return; }
      const q = encodeURIComponent(term);
      const base = (PL.routes.search || '/search');
      try {
        const res = await fetch(`${base}?q=${q}&type=product&options%5Bprefix%5D=last&section_id=${encodeURIComponent(this.dataset.sectionId)}`);
        if (!res.ok) throw new Error(String(res.status));
        const doc = parseHTML(await res.text());
        const vendor = (this.dataset.vendor || '').toLowerCase();
        const self = this.dataset.handle;
        const limit = Number(this.dataset.limit || 8);
        const cards = $$('[data-same-results] .slider__slide', doc).filter((li) => {
          const card = $('[data-product-handle]', li);
          const v = (li.dataset.vendor || '').toLowerCase();
          return card && card.dataset.productHandle !== self && v !== vendor;
        }).slice(0, limit);
        if (term !== this.current) return;
        this.track.innerHTML = '';
        cards.forEach((li) => this.track.appendChild(document.importNode(li, true)));
        const label = $('[data-same-flavor]', this);
        if (label) label.textContent = term;
        this.hidden = cards.length === 0;
        if (cards.length) initWishlistButtons(this);
      } catch (e) {
        this.hidden = true;
      }
    }
  }
  if (!customElements.get('same-flavor')) customElements.define('same-flavor', SameFlavor);

  /* ---------- Produits consultés (badge « compatible ») : mémorisés dans le navigateur, rien n'est envoyé ---------- */
  (() => {
    const info = $('product-info[data-handle]');
    if (!info || info.closest('dialog')) return;
    const h = info.dataset.handle;
    const list = (storage.get('pl_recent', []) || []).filter((x) => typeof x === 'string' && x !== h);
    list.unshift(h);
    const recent = list.slice(0, 12);
    storage.set('pl_recent', recent);
    const map = storage.get('pl_compat', {}) || {};
    const comp = String(info.dataset.compat || '').split(',').filter(Boolean);
    if (comp.length) map[h] = comp.slice(0, 20); else delete map[h];
    Object.keys(map).forEach((k) => { if (!recent.includes(k)) delete map[k]; });
    storage.set('pl_compat', map);
    if (PL.badges) PL.badges.compat(document);
  })();

  /* ---------- v111 : téléphone, fiche en deux colonnes : jamais d'espace blanc à côté ni sous la photo ----------
     La colonne de droite (marque, titre, badges, stock, option courte) se termine au bas de la photo :
     - plus courte que la photo : l'écart est réparti entre ses lignes (--pl-fill, au plus 30 px par intervalle) ;
     - plus haute (titre long sur petit écran) : titre un peu plus petit (pl-tight) ; si cela ne suffit pas, l'option courte
       (Format, Nicotine…) repasse sous la photo, sur toute la largeur (pl-side-full). Tolérance : 14 px (pastille de prix).
     Mesures recalculées au chargement des polices, au changement de taille d'écran et de variante. Rien sur ordinateur. */
  (() => {
    const layout = $('.product .product__layout');
    if (!layout) return;
    const gal = $(':scope > .product__gallery', layout);
    if (!gal) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const rightItems = () => $$(':scope > .product__info > *, :scope > .product__info > variant-picker > *', layout).filter((e) => e.offsetHeight > 0 && getComputedStyle(e).gridColumnStart === '2');
    const over = () => {
      const items = rightItems();
      if (!items.length) return 0;
      return Math.max(...items.map((e) => e.getBoundingClientRect().bottom)) - gal.getBoundingClientRect().bottom;
    };
    const balance = () => {
      layout.style.removeProperty('--pl-fill');
      layout.classList.remove('pl-side-full', 'pl-tight');
      if (!mq.matches || getComputedStyle(gal).gridColumnStart !== '1') return;
      // Tolérance de 14 px : la pastille de prix déborde d'autant sous le cadre de la photo
      let d = over();
      if (d > 14) { layout.classList.add('pl-tight'); const d2 = over(); if (d2 >= d) layout.classList.remove('pl-tight'); else d = d2; }
      if (d > 14 && $('.variant-picker__option--side', layout)) { layout.classList.add('pl-side-full'); d = over(); }
      const n = rightItems().length;
      if (d < -2 && n > 1) layout.style.setProperty('--pl-fill', `${Math.min(30, Math.floor(-d / (n - 1)))}px`);
    };
    let raf = 0;
    const later = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(balance); };
    balance();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
    window.addEventListener('resize', later, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', later);
    layout.addEventListener('variant:change', later);
  })();
})();
